import React from "react";
import { Grid, Typography } from "@mui/material";
import useStyles from "./Styles";

const Header: React.FC = () => {
  const { classes } = useStyles();

  return (
    <Grid container>
      <Grid item xs={12} sm={6}>
        <Typography className={classes.headText}>Last 7 days chats</Typography>
      </Grid>
    </Grid>
  );
};

export default Header;
